var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row legend"},[_c('div',{staticClass:"col-3 legend--label"},[_vm._v("Legende")]),_c('div',{staticClass:"col-3 icons--age"},[_vm._v("Leeftijd")]),_c('div',{staticClass:"col-3 icons--operations"},[_vm._v("Werking")]),_c('div',{staticClass:"col-3 icons--district"},[_vm._v("Wijk")])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3022d59e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/entities/Legend.vue
// module id = null
// module chunks = 